// Configuration file for API endpoints
// Automatically detects environment and uses appropriate URLs

console.log('=== config.js is loading... ===');

const isDevelopment = process.env.NODE_ENV === 'development';

console.log('=== NODE_ENV:', process.env.NODE_ENV, '===');
console.log('=== isDevelopment:', isDevelopment, '===');

// We currently host the customer site under two co-existing apex domains:
// `farmetohome.com` (legacy) and `farmersmarketspace.com` (new). Pick the
// matching API/admin host from the frontend's own hostname so a visitor stays
// on a single domain family for the entire session. Falls back to the
// farmersmarketspace.com hosts when the hostname is unknown (e.g. previews).
const getProductionHosts = () => {
  const fallback = {
    api: 'https://api.farmersmarketspace.com',
    admin: 'https://admin.farmersmarketspace.com',
  };
  if (typeof window === 'undefined') return fallback;
  const host = window.location.hostname || '';
  if (host.endsWith('farmetohome.com')) {
    return {
      api: 'https://api.farmetohome.com',
      admin: 'https://admin.farmetohome.com',
    };
  }
  if (host.endsWith('farmersmarketspace.com')) {
    return {
      api: 'https://api.farmersmarketspace.com',
      admin: 'https://admin.farmersmarketspace.com',
    };
  }
  return fallback;
};

const productionHosts = getProductionHosts();

export const config = {
  // API Base URL - automatically switches between local and production.
  // In production we mirror whichever domain the user is on so farmetohome.com
  // and farmersmarketspace.com stay independent until we sunset the legacy one.
  API_BASE: process.env.REACT_APP_API_BASE || (isDevelopment ? 'http://localhost:4000' : productionHosts.api),

  // Admin URL - automatically switches between local and production
  ADMIN_URL: process.env.REACT_APP_ADMIN_URL || (isDevelopment ? 'http://localhost:3001' : productionHosts.admin),

  // Stripe — one platform publishable key for orders, memberships, and Connect
  STRIPE_PLATFORM_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PLATFORM_PUBLISHABLE_KEY,

  // Test environment variable
  TEST_VAR: process.env.REACT_APP_TEST_VAR,

  // Environment detection
  isDevelopment,
  isProduction: process.env.NODE_ENV === 'production'
};

console.log('=== config object created:', config, '===');

// Log the current configuration (only in development)
if (isDevelopment) {
  console.log('=== Development Environment Detected ===');
  console.log('API Base:', config.API_BASE);
  console.log('Admin URL:', config.ADMIN_URL);
  console.log('Stripe Platform Key:', config.STRIPE_PLATFORM_PUBLISHABLE_KEY ? 'SET' : 'MISSING');
  console.log('Environment Variable:', process.env.REACT_APP_STRIPE_PLATFORM_PUBLISHABLE_KEY);
  console.log('All Environment Variables:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')));
  console.log('NODE_ENV:', process.env.NODE_ENV);
  console.log('Current working directory:', window.location.href);

  if (!config.STRIPE_PLATFORM_PUBLISHABLE_KEY) {
    console.warn('WARNING: STRIPE_PLATFORM_PUBLISHABLE_KEY is not set. Stripe functionality will not work.');
    console.warn('Set REACT_APP_STRIPE_PLATFORM_PUBLISHABLE_KEY in the frontend .env file.');
  }
}
